import DOMPurify from 'dompurify';

export const sanitizeHTML = (dirty) => {
  return DOMPurify.sanitize(dirty, {
    ALLOWED_TAGS: ['b', 'i', 'em', 'strong', 'a', 'p', 'br'],
    ALLOWED_ATTR: ['href', 'target']
  });
};

export const sanitizeSVG = (dirty) => {
  return DOMPurify.sanitize(dirty, {
    USE_PROFILES: {svg: true, svgFilters: true}
  });
};
